/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import MaterialTable, { MTableToolbar, EditComponentProps, Column } from 'material-table';
import {
    Breadcrumbs,
    Typography,
    Chip,
} from '@material-ui/core';
import { IAutoCompleteItem } from '../../typings/autoComplete';
import { Icons } from 'material-table';
import { forwardRef } from 'react';
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../Dashboard/Component/DialogBox';
import { AreaOfLawSelector } from '../../enquirySummary/selectors/AreaOfLawSelector';
import { useStyles } from '../../lookupConfiguration/common/tabsStyle';
import { ExternalEmailTemplateSelector } from '../selectors/ExternalEmailTemplateSelector';
import { 
    EmailTemplateList, 
    EmailTemplateListQueryData, 
    EmailTemplateListQueryParams, 
    EmailTemplateTypeEnum, 
    retrieveEmailTemplateListData, 
    subscriptionEmailTemplate 
} from '../EmailTemplateRespository';
import { showNotification } from '../../App';
import { NewEnquiryResponseDialog } from '../dialogs/NewEnquiryResponseDialog';
import gql from 'graphql-tag';
import { client } from '../..';
import { EmailStyle } from '../tabs/NewEnquiryResponseTemplateTab';
import { UserFeature, UserFeatureEnum } from '../../types/UserFeature';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

// tslint:disable-next-line: no-any
const MemoizedMaterialTable = React.memo(function MemoizedMaterialTable(props: any) {
    return <MaterialTable {...props} />;
// tslint:disable-next-line: no-any
}) as any as typeof MaterialTable;

export interface NewEnquiryResponseTableData {
    // tslint:disable-next-line: no-any
    areaOfLaw: IAutoCompleteItem | any;
    // tslint:disable-next-line: no-any
    // externalTemplate: IAutoCompleteItem | any;
}

interface TableData extends NewEnquiryResponseTableData {
    tableData: { 
        checked: boolean;
        id: number;
    };
    // tslint:disable-next-line: no-any
    externalTemplate: IAutoCompleteItem | any;
    isActive: boolean;
}

interface NewEnquiryResponseTableProps {
    emailType: EmailTemplateTypeEnum;
    className?: string;
    onDataChanged?: (isDataChanged: boolean) => void;
    onRowClick?: (
        event?: React.MouseEvent,
        // tslint:disable-next-line: no-any
        rowData?: any,
        toggleDetailPanel?: (panelIndex?: number) => void
      ) => void;
    getFirstData?: (data: EmailTemplateList) => void;
    // tslint:disable-next-line: no-any
    onSelection?: (areaOfLaw: IAutoCompleteItem | null, externalTemplate: IAutoCompleteItem | null | any) => void;
    // tslint:disable-next-line: no-any
    onAddTemplate?: (areaOfLaw: IAutoCompleteItem | null, externalTemplate: IAutoCompleteItem | null | any) => void;
}

interface NewEnquiryResponseTableState {
    // tslint:disable-next-line: no-any
    data: NewEnquiryResponseTableData[];
    // tslint:disable-next-line: no-any
    selectedData: any | null;
    isLoading: boolean;
    scope?: string;
    selectedRow: number;

    isFormOpen: boolean;

    areaOfLaw: IAutoCompleteItem | null;
    // tslint:disable-next-line: no-any
    externalTemplate: IAutoCompleteItem | null | any;
    integrationTemplateId: string | null;
    emailStyle: number | null;
    emailTemplateGuid: string | null;
    onFirstLoad: boolean;
    isAllExists: boolean;
    isAllExistsGuid: string | null;
}

function NewEnquiryResponseTableInner(props: NewEnquiryResponseTableProps) {

    const classes = useStyles();

    const [state, setState] = useState<NewEnquiryResponseTableState>({
        isLoading: false,
        data: [],
        selectedRow: 0,
        isFormOpen: false,
        areaOfLaw: null,
        externalTemplate: null,
        integrationTemplateId: null,
        emailStyle: null,
        selectedData: null,
        emailTemplateGuid: null,
        onFirstLoad: true,
        isAllExists: false,
        isAllExistsGuid: null
    });

    useEffect(() => {
        fetchEmailTemplateListData(null);
    // tslint:disable-next-line: align
    }, []);

    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

    const selectedDataRef = useRef(state.selectedData);
    const selectedRowRef = useRef(state.selectedRow);
    selectedDataRef.current = state.selectedData;
    selectedRowRef.current = state.selectedRow;

    const tableIcons: Icons = useMemo(() => ({
        Add: forwardRef((iconProps, ref) => <AddBox {...iconProps} ref={ref} className={classes.icon} />),
        Check: forwardRef((iconProps, ref) => <Check {...iconProps} ref={ref} className="check-button" />),
        Clear: forwardRef((iconProps, ref) => <Clear {...iconProps} ref={ref}  className={classes.icon} />),
        Delete: forwardRef((iconProps, ref) => <DeleteOutline {...iconProps} ref={ref}  className={classes.icon} />),
        DetailPanel: forwardRef((iconProps, ref) => <ChevronRight {...iconProps} ref={ref}  className={classes.icon} />),
        Edit: forwardRef((iconProps, ref) => <Edit {...iconProps} ref={ref}  className={classes.icon} />),
        Export: forwardRef((iconProps, ref) => <SaveAlt {...iconProps} ref={ref}  className={classes.icon} />),
        Filter: forwardRef((iconProps, ref) => <FilterList {...iconProps} ref={ref}  className={classes.icon} />),
        FirstPage: forwardRef((iconProps, ref) => <FirstPage {...iconProps} ref={ref}  className={classes.icon} />),
        LastPage: forwardRef((iconProps, ref) => <LastPage {...iconProps} ref={ref}  className={classes.icon} />),
        NextPage: forwardRef((iconProps, ref) => <ChevronRight {...iconProps} ref={ref}  className={classes.icon} />),
        PreviousPage: forwardRef((iconProps, ref) => <ChevronLeft {...iconProps} ref={ref}  className={classes.icon} />),
        ResetSearch: forwardRef((iconProps, ref) => <Clear {...iconProps} ref={ref}  className={classes.icon} />),
        Search: forwardRef((iconProps, ref) => <Search {...iconProps} ref={ref}  className={classes.icon} />),
        SortArrow: forwardRef((iconProps, ref) => <ArrowDownward {...iconProps} ref={ref} />),
        ThirdStateCheck: forwardRef((iconProps, ref) => <Remove {...iconProps} ref={ref}  className={classes.icon} />),
        ViewColumn: forwardRef((iconProps, ref) => <ViewColumn {...iconProps} ref={ref}  className={classes.icon} />)
    }), [classes.icon]);

    useEffect(() => {
        const subscribeEmailObj = subscribeEmail();

        return () => {
            subscribeEmailObj.unsubscribe();
        };
    // tslint:disable-next-line: align
    }, []);

    const subscribeEmail = () => {
        return (
            // let subscription =
            client
                .subscribe({
                    fetchPolicy: 'no-cache',
                    query: subscriptionEmailTemplate,
                    variables: {},
                })
                .subscribe({
                    // tslint:disable-next-line:no-any
                    next(results: any) {
                        if (results.data.emailTemplateNotification.status) {

                            const { emailTemplateNotification } = results.data;
                            showNotification('Success', emailTemplateNotification.message, 'info');

                            fetchEmailTemplateListData(null);

                        } else {
                            showNotification('Failed', results.data.emailTemplateNotification.message, 'error');
                        }
                    },
                    // tslint:disable-next-line:no-any
                    error(err: any) {
                        // tslint:disable-next-line:no-console
                        console.error(err);
                        showNotification(null, err, 'error');
                    },
                })
        );
    };

    const fetchEmailTemplateListData = (integrationTemplateId: string | null) => {   

        setState((prevState) => {
            return {
                ...prevState,
                isLoading: true
            };
        });
        // Search for the Firm when page loads
        let emailTemplateQueryParams: EmailTemplateListQueryParams = {
            emailType: EmailTemplateTypeEnum[props.emailType],
            integrationTemplateId: integrationTemplateId
        };

        retrieveEmailTemplateListData(
            emailTemplateQueryParams,
            true,
            // tslint:disable-next-line: no-any
            (data: any) => onDataRetrieved(data),
            // tslint:disable-next-line:no-any
            function (reason: any): void {
              showNotification(null, reason, 'error');
          });
    };

    const onDataRetrieved = (data: EmailTemplateListQueryData) => {
        let emailTemplateListData = data.templates.emailTemplateList.map((template: EmailTemplateList, index: number) => {
            const matchedPropertys = template.matchedPropertys.matchedProperty[0];

            if (index === 0 && props.getFirstData && state.onFirstLoad) {
                props.getFirstData(template);
            }

            return {
                ...template,
                areaOfLaw: matchedPropertys ? { label: matchedPropertys.keyDescription, value: matchedPropertys.key } : null,
                // tslint:disable-next-line: max-line-length
                externalTemplate: template.integrationTemplateName && template.integrationTemplateId ? { label: template.integrationTemplateName, value: template.integrationTemplateId } : null,
                tableData: {
                    id: index
                },
            };
        });

        setState((prevState) => {
            return {
                ...prevState,
                data: emailTemplateListData,
                isLoading: false,
                onFirstLoad: false,
            };
        });

        isAllTemplateExists(emailTemplateListData);
    };

    // tslint:disable-next-line: no-any
    const onAddData = useCallback((event: any, data: any | any[]) => {
        setState((prevState) => {
            return {
                ...prevState,
                isFormOpen: true,
                emailStyle: null,
                integrationTemplateId: null,
                areaOfLaw: null,
                externalTemplate: null,
                emailTemplateGuid: null,
                selectedData: null,
                // selectedRow: -1,
            };
        });
    }, []);

    // tslint:disable-next-line: no-any
    const onEditData = useCallback((event: any, data: any | any[]) => {

        setState((prevState) => {

            return {
                ...prevState,
                emailStyle: data.emailStyle,
                integrationTemplateId: data.integrationTemplateId,
                areaOfLaw: data.areaOfLaw,
                externalTemplate: data.externalTemplate,
                emailTemplateGuid: data.emailTemplateGuid,
                isFormOpen: true,
                selectedData: data
                // selectedRow: data.tableData.id,
            };
        });
    }, []);

    // tslint:disable-next-line: no-any
    const onDeleteData = useCallback((event: any, data: any | any[]) => {

        setShowDeleteConfirm(true);

        setState((prevState) => {
            return {
                ...prevState,
                selectedData: data
            };
        });
    }, []);

    const onDeleteConfirm = (agree: boolean) => {        
        if (agree) {
            setState((prevState) => {

                const tempselectedData = state.selectedData;

                const tdata = [...prevState.data];
                if (state.selectedData !== null) {
                    tdata.splice(tdata.indexOf(state.selectedData), 1);

                    client.mutate({
                        mutation: DeleteEmailTemplate,
                        variables: {
                            emailType: EmailTemplateTypeEnum[props.emailType], 
                            emailStyle: tempselectedData.emailStyle ? EmailStyle[tempselectedData.emailStyle] : null,
                            emailTemplateGuid: tempselectedData.emailTemplateGuid,

                            isInternalRole: null,
                            roleId: null,
                            selectedUserId: null,                           
                            integrationTemplateId: tempselectedData.integrationTemplateId ? tempselectedData.integrationTemplateId : null,
                            
                        }
                    })
                      // tslint:disable-next-line: no-any
                    .then((results: { data: any }) => {
                        if (results.data) {
                            if (results.data.error === null || results.data.error === undefined) {
                                showNotification(null, 'Successfully deleted', 'info');
            
                                setState((prevInnerState) => {
                                    return {
                                        ...prevInnerState,
                                        isLoading: false,
                                        isRowSelected: false,
                                        selectedData: null
                                    };
                                });
            
                                if (props.onDataChanged) {
                                    props.onDataChanged(false);
                                }
            
                            } else {
                                showNotification('Failed to delete email template', results.data.error, 'error');
                                if (props.onDataChanged) {
                                    props.onDataChanged(true);
                                }
                            }
                        }
                    })
                    // tslint:disable-next-line:no-any
                    .catch((reason: any) => {
                        showNotification('Failed to delete email template', reason, 'error');
                        
                        if (props.onDataChanged) {
                            props.onDataChanged(true);
                        }
                    });
                }
                
                return {
                    ...prevState,
                    data: tdata 
                };
            });
        }

        setShowDeleteConfirm(false);
    };

    // tslint:disable-next-line: no-any
    const onRowClick = useCallback((event?: React.MouseEvent, rowData?: any, toggleDetailPanel?: (panelIndex?: number) => void) => {

        if (rowData) {
            setState((prevState) => {

                if (props.onRowClick) {
                    props.onRowClick(event, rowData, toggleDetailPanel);
                }

                return {
                    ...prevState,
                    selectedRow: rowData.tableData.id,
                    // emailStyle: rowData.emailStyle,
                    // integrationTemplateId: rowData.integrationTemplateId,
                    // areaOfLaw: rowData.areaOfLaw,
                    // externalTemplate: rowData.externalTemplate,
                };
            });
        }
    }, [props.onRowClick]);

    // tslint:disable-next-line: no-any
    const onDialogDataChanged = (selectedData: any | null) => {
        // tslint:disable-next-line: no-console
        console.log('add', selectedData);

        let tdata: NewEnquiryResponseTableData[] = state.data;

        if (props.getFirstData && selectedData.emailTemplateGuid) {
            props.getFirstData(selectedData);
        }

        if (selectedData.emailTemplateGuid) {
            tdata[tdata.indexOf(state.selectedData)] = selectedData;
        } else {

            tdata.push(selectedData);
        }

        setState((prevState) => {
            return {
                ...prevState,
                selectedRow: selectedData.emailTemplateGuid ? selectedData.tableData.id : 0, // prevState.data.length,
                emailStyle: selectedData.emailStyle,
                integrationTemplateId: selectedData.integrationTemplateId,
                areaOfLaw: selectedData.areaOfLaw,
                externalTemplate: selectedData.externalTemplate,
                emailTemplateGuid: selectedData.emailTemplateGuid,
                isFormOpen: true,
                data: tdata
            };
        });
    };

    // tslint:disable-next-line: no-any
    const areaOfLawRender = (data: TableData) => {
        if (data.areaOfLaw) {
            return <div>{data.areaOfLaw.label}</div>;
        }
        return <div>All</div>;              
    };

    // tslint:disable-next-line: no-any
    const isAllTemplateExists = (data?: any) => {
        let isAllExists = false;
        let isAllExistsGuid: string | null = null;

        if (data) {
            // tslint:disable-next-line: no-any
            data.forEach( (row: any) => {
                if (row.matchedPropertys && row.matchedPropertys.matchedProperty && row.matchedPropertys.matchedProperty.length === 0) {
                    isAllExists = true;
                    isAllExistsGuid = row.emailTemplateGuid;
                }
            });
        }

        setState((prevState) => {
            return {
                ...prevState,
                isAllExists: isAllExists,
                isAllExistsGuid: isAllExistsGuid
            };
        });
    };

    // tslint:disable-next-line: no-any
    const areaOfLawSelectorComponent = (componentProps: EditComponentProps<any>) => {
        return (
            <AreaOfLawSelector 
                name="areaOfLaw"
                label=" Area Of Law"
                // required={true}
                onSelection={(selection: IAutoCompleteItem, name: string) => {

                    // setState((prevState) => {
                    //     return {
                    //         ...prevState,
                    //         tempAreaOfLaw: selection
                    //     };
                    // });

                    // if (props.onSelection) {
                    //     props.onSelection(selection, state.tempExernalTemplate);
                    // }
                    componentProps.onChange(selection);
                }}
                value={componentProps.value}
                className={classes.textField}
                error={componentProps.error}
            />
        );
    };

    // tslint:disable-next-line: no-any
    const externalTemplateRenderrer = (data: TableData) => {
        if (data.externalTemplate) {
            return <div>{data.externalTemplate.label}</div>;
        }
        return undefined;
    };

    // tslint:disable-next-line: no-any
    const externalTemplateSelectorComponent = (componentProps: EditComponentProps<any>) => {
        return (
            <ExternalEmailTemplateSelector 
                name="externalTemplate"
                label="External Template"
                // required={true}
                // tslint:disable-next-line: no-any
                onSelection={(selection: IAutoCompleteItem | any, name: string) => {
                    // setState((prevState) => {
                    //     return {
                    //         ...prevState,
                    //         tempExernalTemplate: selection
                    //     };
                    // });

                    // if (props.onSelection) {
                    //     props.onSelection(state.tempAreaOfLaw, selection);
                    // }
                    componentProps.onChange(selection);
                }}
                value={componentProps.value}
                className={classes.textField}
                error={componentProps.error}
            />
        );
    };

    const isActiveRenderrer = (data: TableData) => {
        if (data.isActive) {
            return (
                <CheckCircleIcon className={classes.isActive} />
            );
        } else {
            return undefined;
        }
    };

    const onCloseForm = () => {
        setState((prevState) => {
            return {
                ...prevState,
                isFormOpen: false
            };
        });
    };

    // implement this if your columns are custom not just string to make the search work
    // tslint:disable-next-line: no-any
    const customFilterAndSearch = (filter: string, rowData: any, columnDef: Column<any>): boolean => {

        if (typeof columnDef.field === 'string' && rowData[columnDef.field] && rowData[columnDef.field].label) {
            
            const columnField = rowData[columnDef.field].label.toLowerCase();
            
            const query = filter.toLowerCase(); // Convert the filter to lowercase
            
            return columnField.toLowerCase().includes(query);
        
        } else {
            return false;
        }
    };

    const tableHeading = useMemo(() => (
        <div className={classes.breadcrumbsWrapper}>
            <Breadcrumbs separator="›" aria-label="breadcrumb" className={classes.breadcrumbs}>
                <Typography color="textPrimary" className={classes.breadcrumbsTitle}>Recipient</Typography>
            </Breadcrumbs>
            <Chip className={classes.chip} label={state.data.length} />
        </div>
    ), [classes, state.data.length]);

    // Shallow copy so MemoizedMaterialTable receives a new data reference when selectedRow changes,
    // forcing a re-render that picks up the updated selectedRowRef in rowStyle.
    const displayData = useMemo(() => [...state.data], [state.data, state.selectedRow]);

    const tableComponents = useMemo(() => ({
        // tslint:disable-next-line: max-line-length
        Toolbar: (toolbarProps: any) => (
            <div className={classes.customToolbar}>
                <MTableToolbar classes={{ highlight: classes.highlight, actions: classes.actions }} {...toolbarProps} />
            </div>
        )
    }), [classes]);

    const tableOptions = useMemo(() => ({
        addRowPosition: 'first' as const,
        // search: true,
        selection: false,
        paging: true,
        pageSize: 20,
        pageSizeOptions: [20, 30, 40, 50],
        // showTitle: true,
        // toolbar: true,
        actionsColumnIndex: -1,
        rowStyle: (rowData: any) => ({
            backgroundColor: (selectedRowRef.current === rowData.tableData.id) ? '#EEE' : '#FFF'
        })
    }), []);

    const tableEditable = useMemo(() => ({}), []);

    const tableActions = useMemo(() => [
        {
            icon: AddIcon,
            tooltip: 'Add',
            isFreeAction: true,
            iconProps: {
                className: classes.icon,
                color: 'primary' as const
            },
            onClick: onAddData
        },
        {
            tooltip: 'Edit',
            icon: Edit,
            iconProps: {
                className: classes.icon,
                color: 'primary' as const
            },
            // tslint:disable-next-line: no-any
            onClick: onEditData
        },
        {
            tooltip: 'Delete',
            icon: DeleteOutline,
            iconProps: {
                className: classes.icon,
                color: 'primary' as const
            },
            // tslint:disable-next-line: no-any
            onClick: onDeleteData
        },
    ], [classes.icon, onAddData, onEditData, onDeleteData]);

    return (
        <div className={`${classes.root} ${props.className}`}>
            <DialogBox
                title="Email Template"
                // tslint:disable-next-line:max-line-length
                content={`Are you sure you want to delete the selected row?`}
                show={showDeleteConfirm}
                isAgree={onDeleteConfirm}
                disAgreeLabel={'No'}
                agreeLabel={'Yes'}
                className={classes.dialogBox}
            />
            {!!state.isFormOpen && (
                <NewEnquiryResponseDialog 
                    open={state.isFormOpen}
                    onClose={onCloseForm}
                    emailType={props.emailType}
                    title="Template"
                    emailStyle={state.emailStyle}
                    integrationTemplateId={state.integrationTemplateId}
                    areaOfLaw={state.areaOfLaw}
                    externalTemplate={state.externalTemplate}
                    emailTemplateGuid={state.emailTemplateGuid}
                    selectedData={state.selectedData}
                    onDataChanged={onDialogDataChanged}
                    isAllExists={state.isAllExists}
                    isAllExistsGuid={state.isAllExistsGuid}
                />
            )}
            <MemoizedMaterialTable
                isLoading={state.isLoading}
                title={tableHeading}
                icons={tableIcons}
                onRowClick={onRowClick}
                columns={[
                    {
                        title: 'Area of Law',
                        field: 'areaOfLaw',
                        // tslint:disable-next-line: max-line-length
                        // validate: (rowData) => rowData.hasOwnProperty('areaOfLaw') && rowData.areaOfLaw ? true : { isValid: false, helperText: 'Area of Law is required'},
                        render: (rowData) => areaOfLawRender(rowData),
                        editComponent: (componentData) => areaOfLawSelectorComponent(componentData),
                        searchable: true,
                        customFilterAndSearch: customFilterAndSearch
                    },
                    {
                        title: 'External Template',
                        field: 'externalTemplate',
                        hidden: !UserFeature.HasAccess(UserFeatureEnum.hasVisionSix),
                        // tslint:disable-next-line: max-line-length
                        // validate: (rowData) => rowData.hasOwnProperty('areaOfLaw') && rowData.areaOfLaw ? true : { isValid: false, helperText: 'Area of Law is required'},
                        render: (rowData) => externalTemplateRenderrer(rowData),
                        editComponent: (componentData) => externalTemplateSelectorComponent(componentData),
                        searchable: true,
                        customFilterAndSearch: customFilterAndSearch
                    },
                    {
                        title: 'Active',
                        field: 'isActive',
                        render: (rowData) => isActiveRenderrer(rowData),
                    },
                ]}
                data={displayData}
                components={tableComponents}
                options={tableOptions}
                editable={tableEditable}
                actions={tableActions}
            />
        </div>
    );
}

const NewEnquiryResponseTable = React.memo(NewEnquiryResponseTableInner);
export default NewEnquiryResponseTable;

export const DeleteEmailTemplate = gql`
    mutation DeleteEmailTemplate(
        $emailType: EmailType,
        $isInternalRole: Boolean,
        $roleId: String,
        $selectedUserId: String,
        $emailStyle: EmailStyle,
        $integrationTemplateId: String,
        $emailTemplateGuid: String
    ){
        deleteEmailTemplate(
            emailType: $emailType,
            isInternalRole: $isInternalRole,
            roleId: $roleId,
            selectedUserId: $selectedUserId,
            emailStyle: $emailStyle,
            integrationTemplateId: $integrationTemplateId,
            emailTemplateGuid: $emailTemplateGuid
        )
    }
`;